import headerstyle from "./Navbar.module.css";
import Image from "next/image";
import homemail from "../../assets/images/header/mail.png";
import homephone from "../../assets/images/header/phone.png";
import Logo from "../../assets/images/header/Logo-with-Background.png";
import { useState, useEffect } from 'react';
import Nav from "./Nav";
import Link from "next/link";
import Head from "next/head";

const NavbarDesk = (props) => {

  const [active, setActive] = useState(props.title);

  const [isSticky, setIsSticky] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsSticky(window.pageYOffset >= sticky);
    };

    const sticky = document.getElementById("navbar").offsetTop;

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);
 

  return (
  <>
   <section className=""id={headerstyle.navbartopbg}>
      <div className="container d-none d-lg-block d-xl-block">
        <div className="row">
          <div className={`${headerstyle.topheaderscroll} col`}>
            <span id={`${headerstyle.toptopleftsec}`}>
              <Image 
                src={homemail} 
                alt="mail icon" 
                title="Mail Link"
                className="img-fluid"
              />

              <span className={`${headerstyle.toptopheader} ps-xl-2 pe-xl-2`}>
                <a href="mailto:admissions@shankarias.in" className={`${headerstyle.toptopheaderlinks}`}>admissions@shankarias.in</a>
              </span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                <Image 
                  src={homephone} 
                  alt="phone icon" 
                  title="Phone Link"
                  className="img-fluid"   
                />

              <span className={`${headerstyle.toptopheader} ps-2 pe-2`}>UPSC :
                <a href="tel: 9003190030" className={`${headerstyle.toptopheaderlinks}`}> &nbsp; 9003190030 &nbsp;&nbsp;</a>
              </span>

              <span className={`${headerstyle.topdot}`}><b id={`${headerstyle.topleft}`}></b></span>
               <Image 
                  src={homephone} 
                  alt="phone icon" 
                  title="Phone Link"
                  className="img-fluid"   
                />
              <span className={`${headerstyle.toptopheader} ps-2 pe-2`}>TNPSC :
                <a href="tel: 044-43533445" className={`${headerstyle.toptopheaderlinks}`}>&nbsp;&nbsp;7667766266 &nbsp;|&nbsp; 044-45543082 &nbsp;|&nbsp;044-43533445 </a>
              </span>
            </span>    

            <div className={`${headerstyle.headerscroll}`}>
              <Link href="/upsc-admission-anna-nagar" className={`${headerstyle.toptopheaderlinks1} ${headerstyle.toptopheader1} pe-lg-4 pe-xl-4`} >
               <span className={active === "upsc" ? `${headerstyle.activeLink} nav-item`: "nav-item"} id="upsc" onClick={() => setActive("upsc")}>Domestic</span>
              </Link>

              <Link href="/upsc-admission-nri" className={`${headerstyle.toptopheaderlinks1} ${headerstyle.toptopheader1} pe-lg-4 pe-xl-4`} >
                <span className={active === "upsc" ? `${headerstyle.activeLink} nav-item`: "nav-item"} id="upsc" onClick={() => setActive("upsc")}>NRI</span>
              </Link>

              <Link href="/contact-us" className={`${headerstyle.toptopheaderlinks} ${headerstyle.toptopheader} pe-lg-3 pe-xl-4`} >
                <span className={active === "contact" ? `${headerstyle.activeLink} nav-item`: "nav-item"} id="contact" onClick={() => setActive("contact")}>Contact</span>
              </Link>

              <Link href="/careers" className={`${headerstyle.toptopheaderlinks} ${headerstyle.toptopheader} pe-lg-4 pe-xl-4`}>
                <span className={active === "career" ? `${headerstyle.activeLink} nav-item`: "nav-item"} id="career" onClick={() => setActive("career")}>Careers</span>
              </Link>

              <a href="/blog" rel="noreferrer" className={`${headerstyle.toptopheaderlinks} ${headerstyle.toptopheader} pe-lg-4 pe-xl-4`}>
                <span className={active === "blog" ? `${headerstyle.activeLink} nav-item`: "nav-item"} id="blog" onClick={() => setActive("blog")}>Blog</span>
              </a>

              <a href="https://admissions.shankariasacademy.com" target={"_blank"} rel="noreferrer" className={`${headerstyle.toptopheaderlinks} ${headerstyle.toptopheader} pe-lg-4 pe-xl-4`}>
                Login
              </a>

              <Link href="/admission-consultation"><button type="button" className={`${headerstyle.headerbutton}`}>Admission Consultation</button></Link>
            </div>
          </div>
        </div>
      </div>

      {/* <div className="container-fluid  d-none d-lg-block d-xl-none">
        <div className="row">
          <div className={`${headerstyle.topheaderscroll} col`}>
            <span id={`${headerstyle.toptopleftsec}`}>
              <Image 
                src={homemail} 
                alt="mail icon" 
                title="Mail Link"
                className="img-fluid"
              />
              <span className={`${headerstyle.toptopheader}`}>
                <a href="mailto:admissions@shankarias.in" className={`${headerstyle.toptopheaderlinks}`}>admissions@shankarias.in</a>
              </span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;

              <Image 
                src={homephone} 
                alt="phone icon" 
                title="Phone Link"
                className="img-fluid"   
              />
            
              <span className={`${headerstyle.toptopheader} ps-1 pe-2`}>UPSC:
                <a href="tel: 9003190030 " className={`${headerstyle.toptopheaderlinks}`}> 9003190030 </a>
              </span>

              <span className={`${headerstyle.topdot}`}><b id={`${headerstyle.topleft}`}>.</b></span>
              <span className={`${headerstyle.toptopheader} ps-1 pe-2`}>TNPSC:
                <a href="tel: 044-43533445" className={`${headerstyle.toptopheaderlinks}`}>&nbsp;&nbsp;044-43533445 &nbsp;|&nbsp; 044-45543082</a>
              </span>
            </span> 

            <div className={`${headerstyle.headerscroll}`}>
              <Link href="/upsc-admission-anna-nagar" className={`${headerstyle.toptopheaderlinks1} ${headerstyle.toptopheader1} pe-lg-3 pe-xl-4`} >
                <span className={active === "upsc" ? `${headerstyle.activeLink} nav-item`: "nav-item"} id="upsc" onClick={() => setActive("upsc")}>Domestic</span>
              </Link>

              <Link href="/upsc-admission-nri" className={`${headerstyle.toptopheaderlinks1} ${headerstyle.toptopheader1} pe-lg-3 pe-xl-4`} >
                <span className={active === "upsc" ? `${headerstyle.activeLink} nav-item`: "nav-item"} id="upsc" onClick={() => setActive("upsc")}>NRI</span>
              </Link>

              <Link href="/contact-us" className={`${headerstyle.toptopheaderlinks} ${headerstyle.toptopheader} pe-lg-3 pe-xl-4`} >
                <span className={active === "contact" ? `${headerstyle.activeLink} nav-item`: "nav-item"} id="contact" onClick={() => setActive("contact")}>Contact</span>
              </Link>

              <Link href="/careers" className={`${headerstyle.toptopheaderlinks} ${headerstyle.toptopheader} pe-lg-3 pe-xl-4`}>
                <span className={active === "career" ? `${headerstyle.activeLink} nav-item`: "nav-item"} id="career" onClick={() => setActive("career")}>Careers</span>
              </Link>

              <a href="/blog" rel="noreferrer" className={`${headerstyle.toptopheaderlinks} ${headerstyle.toptopheader} pe-lg-3 pe-xl-4`}>
                <span className={active === "blog" ? `${headerstyle.activeLink} nav-item`: "nav-item"} id="blog" onClick={() => setActive("blog")}>Blog</span>
              </a>

              <a href="https://admissions.shankariasacademy.com/online/" target={"_blank"} rel="noreferrer" className={`${headerstyle.toptopheaderlinks} ${headerstyle.toptopheader} pe-lg-3 pe-xl-4`}>                       
                Login
              </a>

              <Link href="/admission-consultation"><button type="button" className={`${headerstyle.headerbutton}`}>Admission Consultation</button></Link>
            </div>
          </div>
        </div>
      </div> */}
    </section>

    <section className= {isSticky ? "sticky" : ""} style={{ background: "#F4F6F8 0% 0% no-repeat padding-box" , boxShadow: "0 1px 0 #d9dfe6" }}
    >
      <div id="navbar">
        <div className="container d-none d-lg-block d-xl-block" >
          <nav className={` navbar navbar-expand-lg py-0`} >
              {/* LEFT MENU */}
              <div className="d-flex gap-lg-2 gap-xl-4 flex-grow-1  p-2">
                <Link href="/" className={`${headerstyle.toptopheader} `}>
                  <button type="button" className="newnav1" >Home</button>
                </Link>

                <Link href="/about-us" className={`${headerstyle.toptopheader} `}>
                  <button type="button" className="newnav1">About</button>
                </Link>

              <div
                className={`${headerstyle.customDropdown} ${
                  active === "sia-courses" ? headerstyle.activeLink : ""
                }`}
                onMouseEnter={() => setActive("sia-courses")}
              >
                <a
                  className={`${headerstyle.headertitles1} nav-link dropdown-toggle cursorPointer`}
                  href="#"
                >
                  <span className="pe-2">UPSC Courses</span>
                </a>

                <ul
                  className={`${headerstyle.customDropdownMenu} ${headerstyle.borderRadius}`}
                >
                  <li className={headerstyle.dropdownItem}>
                    <Link
                      href="/upsc-admission-anna-nagar"
                      className={`${headerstyle.headerdropdown} ${headerstyle.dropdownLink}`}
                    >
                      UPSC 2026 Admissions Open – Pre-Booking Now
                    </Link>
                  </li>

                  <li className={headerstyle.dropdownItem}>
                    <Link
                      href="/"
                      className={`${headerstyle.headerdropdown} ${headerstyle.dropdownLink}`}
                    >
                      UPSC Prelims 2026 - Cut off Prediction
                    </Link>
                  </li>

                  <li className={headerstyle.dropdownItem}>
                    <Link
                      href="/upsc-mains-crash-course"
                      className={`${headerstyle.headerdropdown} ${headerstyle.dropdownLink}`}
                    >
                      UPSC Mains Crash Course 2026
                    </Link>
                  </li>

                  <li className={headerstyle.dropdownItem}>
                    <Link
                      href="/upsc-mains-test-series/"
                      className={`${headerstyle.headerdropdown} ${headerstyle.dropdownLink}`}
                    >
                      UPSC Mains Test Series - Moksha 2026 
                    </Link>
                  </li>

                  <li className={headerstyle.dropdownItem}>
                    <Link
                      href="/upsc-mains-crash-course"
                      className={`${headerstyle.headerdropdown} ${headerstyle.dropdownLink}`}
                    >
                      Sadhana (II Year UPSC Foundation Course) 
                    </Link>
                  </li>

                  <li className={headerstyle.dropdownItem}>
                    <Link
                      href="/upsc-optional-test-series"
                      className={`${headerstyle.headerdropdown} ${headerstyle.dropdownLink}`}
                    >
                     UPSC Optional Programme - 2026
                    </Link>
                  </li>

                  <li className={headerstyle.dropdownItem}>
                    <Link
                      href="/upsc-optional-test-series"
                      className={`${headerstyle.headerdropdown} ${headerstyle.dropdownLink}`}
                    >
                      UPSC Optional Test Series - Moksha 2026
                    </Link>
                  </li>
                </ul>
              </div>

              <div
                className={`${headerstyle.customDropdown} ${
                  active === "sia-courses" ? headerstyle.activeLink : ""
                }`}
                onMouseEnter={() => setActive("sia-courses")}
              >
                <a
                  className={`${headerstyle.headertitles1} nav-link dropdown-toggle cursorPointer`}
                  href="#"
                >
                  <span className="pe-2">TNPSC Courses</span>
                </a>

                <ul
                  className={`${headerstyle.customDropdownMenu} ${headerstyle.borderRadius}`}
                >
                  <li className={headerstyle.dropdownItem}>
                    <Link
                      href="/tnpsc-admissions/#gspcm"
                      className={`${headerstyle.headerdropdown} ${headerstyle.dropdownLink}`}
                    >
                      TNPSC Gr I Preliminary & Mains (PCM)
                    </Link>
                  </li>

                  <li className={headerstyle.dropdownItem}>
                    <Link
                      href="/tnpsc-admissions/#gspcm"
                      className={`${headerstyle.headerdropdown} ${headerstyle.dropdownLink}`}
                    >
                      TNPSC Group I & II Preliminary Course 2026
                    </Link>
                  </li>

                  <li className={headerstyle.dropdownItem}>
                    <Link
                      href="/tnpsc-general-enrichment-test-series"
                      className={`${headerstyle.headerdropdown} ${headerstyle.dropdownLink}`}
                    >
                      I'M TOP TNPSC GT & GE Enrichment Test Series - 2026
                    </Link>
                  </li>

                  <li className={headerstyle.dropdownItem}>
                    <Link
                      href="/tnpsc-group-II-IIA-prelims-test-series"
                      className={`${headerstyle.headerdropdown} ${headerstyle.dropdownLink}`}
                    >
                     I'M TOP TNPSC Group II/IIA Prelims Test Series 2026
                    </Link>
                  </li>
                </ul>
              </div>

              </div>

                {/* RIGHT MENU */}
              <div className="d-flex gap-lg-2 gap-xl-4 flex-grow-2 justify-content-center ">


               <div
                className={`${headerstyle.customDropdown} ${
                  active === "sia-courses" ? headerstyle.activeLink : ""
                }`}
                onMouseEnter={() => setActive("sia-courses")}
              >
                <a
                  className={`${headerstyle.headertitles1} nav-link dropdown-toggle cursorPointer`}
                  href="#"
                >
                  <span className="pe-2">Learning Corner</span>
                </a>

                <ul
                  className={`${headerstyle.customDropdownMenu} ${headerstyle.borderRadius}`}
                >
                  <li className={headerstyle.dropdownItem}>
                    <Link
                      href="/tnpsc-admissions/#gspcm"
                      className={`${headerstyle.headerdropdown} ${headerstyle.dropdownLink}`}
                    >
                      Studty Material
                    </Link>
                  </li>

                  <li className={headerstyle.dropdownItem}>
                    <Link
                      href="/tnpsc-admissions/#gspcm"
                      className={`${headerstyle.headerdropdown} ${headerstyle.dropdownLink}`}
                    >
                      Current Affairs
                    </Link>
                  </li>

                  <li className={headerstyle.dropdownItem}>
                    <Link
                      href="/tnpsc-general-enrichment-test-series"
                      className={`${headerstyle.headerdropdown} ${headerstyle.dropdownLink}`}
                    >
                     Upsc Mentoring Online Support
                    </Link>
                  </li>
                </ul>
              </div>

                {/* <Link href="/contact-us" className={headerstyle.toptopheader}>
                  <button type="button" className="newnav1">Contact</button>
                </Link>  */}

                
                <Link href="/our-achievers" className={`${headerstyle.toptopheader} `}>
                  <button type="button" className="newnav1">Achievements</button>
              </Link>

                {/* <Link href="/learning" className={headerstyle.toptopheader}>
                  <button type="button" className="newnav1">LEARNING CORNER</button>
                </Link> */}
              {/* 
                */}

                <Link href="https://www.shankariasacademy.com/blog/institute-day-2024-20-years-celebration/" className={headerstyle.toptopheader}>
                  <button type="button" className="newnav1">Event Gallery</button>
                </Link>
              </div>
          </nav>
          
          <div className="text-center flex-grow-0">
            <div  className= {`${headerstyle.logo3d}`}>
              <Link href="/" className="">
                <Image
                  src={Logo}
                  alt="Academy Logo"
                  title="Shankar IAS Academy"
                  className="img-fluid"
                  style={{ height: "96px", width: "auto" }}
                />
              </Link>
            </div>
          </div> 
        </div>
      </div>
    </section>

    {/* <section className="">
      <div id="navbar" className={isSticky ? "sticky" : ""}>
        <div className="container-fluid d-lg-block d-xl-none d-none"style={{ background: "#F4F6F8 0% 0% no-repeat padding-box" , boxShadow: "0 1px 0 #d9dfe6" }} >
          <nav className={` navbar navbar-expand-lg py-0`} >
              
              <div className="d-flex flex-grow-1 gap-2  p-2">
                <Link href="/" className={`${headerstyle.toptopheader} `}>
                  <button type="button" className="newnav1" >HOME</button>
                </Link>

                <Link href="/about-us" className={`${headerstyle.toptopheader} `}>
                  <button type="button" className="newnav1">ABOUT US</button>
                </Link>

                    <div
                  className={
                    active === "sia-courses"
                      ? `${headerstyle.activeLink} nav-item dropdown `
                      : "nav-item dropdown"
                  }
                  onClick={() => setActive("sia-courses")}
                >
                  <a
                    className={`${headerstyle.headertitles1} nav-link dropdown-toggle cursorPointer`}
                    href="#"
                    role="button"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                  >
                    <span className="pe-2">SIA COURSES</span>
                  </a>

                  <ul className={`${headerstyle.borderRadius} dropdown-menu`}>

                    <li>
                      <Link
                        href="/upsc-admission-anna-nagar"
                        className={`${headerstyle.headerdropdown} dropdown-item pt-2`}
                      >
                        UPSC
                      </Link>
                    </li>


                    <li>
                      <Link
                        href="/tnpsc-admissions"
                        className={`${headerstyle.headerdropdown} dropdown-item pt-2`}
                      >
                        TNPSC
                      </Link>
                    </li>

                    <li>
                      <Link
                        href="https://www.shankarbankingacademy.com/"
                        className={`${headerstyle.headerdropdown} dropdown-item pt-2`}
                      >
                        Banking
                      </Link>
                    </li>
                  </ul>
              </div>

                 <Link href="/our-achievers" className={`${headerstyle.toptopheader} `}>
                  <button type="button" className="newnav1">ACHIEVEMENTS</button>
                </Link>


              </div>

             
              <div className="d-flex gap-2 flex-grow-1 justify-content-end ">

                    <div
                  className={
                    active === "sia-courses"
                      ? `${headerstyle.activeLink} nav-item dropdown `
                      : "nav-item dropdown"
                  }
                  onClick={() => setActive("learning-corner")}
                >
                  <a
                    className={`${headerstyle.headertitles1} nav-link dropdown-toggle cursorPointer`}
                    href="#"
                    role="button"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                  >
                    <span className="pe-2">LEARNING CORNER</span>
                  </a>

                  <ul className={`${headerstyle.borderRadius} dropdown-menu`}>

                    <li>
                      <Link
                        href="https://www.shankariasacademy.com/postalmaterial/"
                        className={`${headerstyle.headerdropdown} dropdown-item pt-2`}
                      >
                       Studty Material
                      </Link>
                    </li>


                    <li>
                      <Link
                        href="/current-affairs"
                        className={`${headerstyle.headerdropdown} dropdown-item pt-2`}
                      >
                        Current Affairs
                      </Link>
                    </li>

                    <li>
                      <Link
                        href="/sia-mentoring"
                        className={`${headerstyle.headerdropdown} dropdown-item pt-2`}
                      >
                        Upsc Mentoring Online Support
                      </Link>
                    </li>
                  </ul>
              </div>
                

                {/* <Link href="/learning" className={headerstyle.toptopheader}>
                  <button type="button" className="newnav1">LEARNING CORNER</button>
                </Link> 

                <Link href="/contact-us" className={headerstyle.toptopheader}>
                  <button type="button" className="newnav1">CONTACT US</button>
                </Link>

                <Link href="https://www.shankariasacademy.com/blog/institute-day-2024-20-years-celebration/" className={headerstyle.toptopheader}>
                  <button type="button" className="newnav1">EVENT GALLERY</button>
                </Link>
              </div>
          </nav>
          
          <div className="text-center flex-grow-0">
            <div  className= {`${headerstyle.logo3d}`}>
              <Link href="/" className="">
                <Image
                  src={Logo}
                  alt="Academy Logo"
                  title="Shankar IAS Academy"
                  className="img-fluid"
                  style={{ height: "96px", width: "auto" }}
                />
              </Link>
            </div>
          </div> 
        </div>
      </div>
    </section> */}


    <Nav title={props.title}/>   
   </>
  )
}
export default NavbarDesk;
